import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/admin/AdminAuthContext";
import { Loader2 } from "lucide-react";

export default function RequireAdmin({ children }) {
  const { user, checking } = useAdminAuth();
  const location = useLocation();

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0a192f] text-[#efeade]">
        <Loader2 className="animate-spin" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return children;
}
